import { backendApi } from "./axios";
import { AUTH_ENDPOINTS } from "./endpoints";

export function login(username, password) {
  return backendApi.post(AUTH_ENDPOINTS.LOGIN, { username, password });
}

export function refreshToken(refreshToken) {
  return backendApi.post(AUTH_ENDPOINTS.REFRESH_TOKEN, { refreshToken });
}

export function register({ username, email, brc, password, role ,enabled}) {
  return backendApi.post(AUTH_ENDPOINTS.REGISTER, { username, email, brc, password, role,enabled });
}

export function resetPassword(payload) {
  return backendApi.post(AUTH_ENDPOINTS.RESET_PASSWORD, payload);
}

export function googleLogin() {
  return backendApi.get(AUTH_ENDPOINTS.GOOGLE_LOGIN);
}

export function googleSignup(role) {
  return backendApi.get(`${AUTH_ENDPOINTS.GOOGLE_SIGNUP}?role=${encodeURIComponent(role)}`);
}

export function setupAuthenticator(payload) {
  return backendApi.get(AUTH_ENDPOINTS.TOTP_SETUP, { params: payload });
}

export function verifyTwoFactor(otp) {
  return backendApi.get(AUTH_ENDPOINTS.TOTP_VERIFY, { params: otp });
}

export function generatePasswordResetToken(payload) {
  return backendApi.post(AUTH_ENDPOINTS.GENERATE_PASSWORD_RESET_TOKEN, payload );
}

export function verifyEmail(email) {
  return backendApi.post(AUTH_ENDPOINTS.VERIFY_EMAIL, { email });
}

export function verifyResetToken(payload) {
  return backendApi.post(AUTH_ENDPOINTS.VERIFY_PASSWORD_RESET_TOKEN, payload );
}

export function verifyEmailBeforeChange(payload) {
  return backendApi.post(AUTH_ENDPOINTS.VERIFY_EMAIL_BEFORE_CHANGE, payload );
}

export function verifyCurrentPassword(payload) {
  return backendApi.post(AUTH_ENDPOINTS.VERIFY_CURRENT_PASSWORD, payload );
}

export function verifyPassword(payload) {
  return backendApi.post(AUTH_ENDPOINTS.VERIFY_PASSWORD, payload);
}

export function toggleTwoFactor(payload) {
  return backendApi.post(AUTH_ENDPOINTS.TOGGLE_TWO_FACTOR, payload );
}

export function fetchRoles() {
  return backendApi.get(AUTH_ENDPOINTS.FETCH_ROLES );
}